import { useQuery } from '@tanstack/react-query'

import { getUserAccountYearMonthSummary } from '@src/api/repositories'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

import { UseFetchUserAccountYearMonthSummaryArgs } from './type'

export const useFetchUserAccountYearMonthSummary = ({
  organizationId,
  fromYearMonth,
  toYearMonth,
}: UseFetchUserAccountYearMonthSummaryArgs) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getUserAccountYearMonthSummary(
        axiosInstance,
        organizationId,
        fromYearMonth,
        toYearMonth
      ),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_USER_ACCOUNT_YEAR_MONTH_SUMMARY,
      fromYearMonth,
      toYearMonth,
    ],
  })

  return { data, isError, isLoading, refetch }
}
